export const useTopLevelData = () => {
  const config = useRuntimeConfig()
  const transform = (response) => {
    const data = (response?.data || []).map((element) => {
      const attributes = element?.attributes || {}
      return {
        id: element?.id ?? null,
        ...attributes      
      }
    })      
    return {
      data: data,        
      meta: response.meta
    }
  }

  const getAllTopLevelDiscounts = async () => {
    const url = `/api/top-level-discounts`; 

    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
  }

  return {   
    getAllTopLevelDiscounts
  }
}